import { create } from 'zustand';

import { STORAGE_KEY } from '@/constants';

const LIMIT_NUM = 5;

interface SearchHistoryStore {
  /** 초기값 undefined — 클라이언트 마운트 후 localStorage에서 로드됨. */
  data: string[] | undefined;
  add: (keyword: string) => void;
  remove: (keyword: string) => void;
  clear: () => void;
}

function writeStorage(next: string[]) {
  localStorage.setItem(STORAGE_KEY.SEARCH_HISTORY, JSON.stringify(next));
}

export const useSearchHistoryStore = create<SearchHistoryStore>((set) => ({
  data: undefined,

  add: (keyword) => {
    const trimmed = keyword.trim();
    if (!trimmed) return;

    set((state) => {
      if (state.data === undefined) return state;

      const filtered = state.data.filter((item) => item !== trimmed);
      if (filtered.length >= LIMIT_NUM) filtered.pop();

      const next = [trimmed, ...filtered];
      writeStorage(next);

      return { data: next };
    });
  },

  remove: (keyword) => {
    set((state) => {
      if (state.data === undefined) return state;

      const next = state.data.filter((item) => item !== keyword);
      writeStorage(next);

      return { data: next };
    });
  },

  clear: () => {
    localStorage.removeItem(STORAGE_KEY.SEARCH_HISTORY);
    set({ data: [] });
  },
}));

// 클라이언트 마운트 후 localStorage에서 data 하이드레이션 (SSR-safe).
if (typeof window !== 'undefined') {
  queueMicrotask(() => {
    const stored = localStorage.getItem(STORAGE_KEY.SEARCH_HISTORY);
    const parsed: unknown = (() => {
      try {
        return stored ? JSON.parse(stored) : [];
      } catch {
        return [];
      }
    })();

    useSearchHistoryStore.setState({
      data: Array.isArray(parsed)
        ? parsed.filter(
            (keyword): keyword is string => typeof keyword === 'string',
          )
        : [],
    });
  });
}
